<template>
    <Dropdown @visibleChange="loadFirst" :getPopupContainer="triggerNode => triggerNode">
        <span class="cursor-pointer">
            <Badge :count="state.unreadCount" :offset="[3, -3]">
                <CIcon class="text-20" file="bell.svg"></CIcon>
            </Badge>
        </span>
        <template v-slot:overlay>
            <Menu :ref="e => (refs.menu = e)" @scroll="onScrollMenu" class="py-0" :style="{ width: '300px', maxHeight: '400px', overflowY: 'auto' }">
                <MenuItem v-if="notificationsComputed.length > 0" class="pre-wrap position-sticky bg-layout-body-background" :style="{ top: 0 }">
                    <div class="text-right">
                        <router-link :to="{ name: 'notifications' }">{{ $t("button.all") }}</router-link>
                    </div>
                </MenuItem>
                <MenuItem v-else class="pre-wrap position-sticky bg-white" :style="{ top: 0 }">
                    <Empty></Empty>
                </MenuItem>
                <MenuItem
                    v-for="notification in notificationsComputed"
                    :key="notification.id"
                    class="pre-wrap"
                    @click="() => onClickNotification(notification)"
                >
                    <div class="d-flex">
                        <div v-if="notification.refFrom?.refImage?.url" class="my-auto mr-2">
                            <Avatar size="large" :src="parseUrl(notification.refFrom.refImage.url)"></Avatar>
                        </div>
                        <div class="text-primary my-auto">
                            <span>{{ notification.title }}</span>
                            <Tag color="green" class="mx-0 ml-2" v-if="!notification.isRead">
                                <small>{{ $t("views.notification.unread") }}</small>
                            </Tag>
                        </div>
                    </div>
                    <div>
                        <small>{{ notification.desc }}</small>
                    </div>
                    <div class="text-right">
                        <small>{{ notification.refFrom?.fullName }} ({{ moment(notification.createDate).format("DD/MM/YYYY HH:mm") }})</small>
                    </div>
                </MenuItem>
                <MenuItem v-if="isLoading" class="text-center">
                    <Spin :spinning="isLoading"></Spin>
                </MenuItem>
            </Menu>
        </template>
    </Dropdown>
</template>

<script>
import { Avatar, Badge, Dropdown, Empty, Menu, Spin, Tag } from "ant-design-vue";
import moment from "moment";
import { computed, defineAsyncComponent, defineComponent, onUnmounted, reactive } from "vue";
import { parseUrl } from "../../../utils/util";
import websocket from "../../../utils/websocket";
import { isLoading, loadFirst, onClickNotification, onScrollMenu, onWebsocketConnect, state } from "./notification.logic";

export default defineComponent({
    components: {
        Dropdown,
        Menu,
        MenuItem: Menu.Item,
        Avatar,
        Tag,
        Spin,
        Badge,
        Empty,
        CIcon: defineAsyncComponent(() => import("../../icon/CIcon"))
    },
    setup() {
        const refs = reactive({ menu: null });
        state.websocketId = websocket.connect(onWebsocketConnect);
        onUnmounted(() => {
            state.websocketSubscribes.forEach(d => websocket.unsubscribe(d.path, d.id));
            state.notifications = [];
            state.websocketSubscribes = [];
            state.page = 0;
            state.unreadCount = 0;
            state.fisrt = false;
            state.end = false;
        });
        const notificationsComputed = computed(() => {
            const notifications = [...state.notifications];
            notifications.sort((o1, o2) => moment(o2.createDate).unix() - moment(o1.createDate).unix());
            return notifications;
        });
        return {
            state,
            refs,
            isLoading,
            notificationsComputed,
            onClickNotification,
            parseUrl,
            moment,
            onScrollMenu,
            loadFirst
        };
    }
});
</script>
